import React from 'react';
import { useMediaQuery } from "beautiful-react-hooks";

import {
    SNumberItem,
    SNumberDescription
} from './styles';

import { TextDeco } from '../../atoms/Typography';

const NumberItem  = ({ itemData, paddingSmall }) => {
    const isSmall = useMediaQuery("(max-width: 370px)");
    const isMedium = useMediaQuery("(max-width: 440px)");
    
    const calculateSize = el => (
        el === "number" ?
        ( isSmall ? "small" : isMedium ? "normal" : "large") :
        ( isSmall ? "extra-small" : isMedium ? "very-small" : "small")
    );

    const {
        prefix,
        data,
        suffix,
        hasNoSuffixSpace,
        description,
    } = itemData;

    return (
        <SNumberItem>
            <div>
                <TextDeco
                    className="list-item-number"
                    value={ prefix }
                    size={ calculateSize() }
                    prefix
                />
                <TextDeco
                    className="list-item-number"
                    value={ data }
                    size={ calculateSize("number") }
                    hasNoSuffixSpace={ hasNoSuffixSpace }
                />
                &nbsp;
                <TextDeco
                    className="list-item-number suffix"
                    value={ suffix }
                    size={ calculateSize() }
                    suffix
                />
            </div>

            <SNumberDescription isPaddingSmall={ paddingSmall }>
                { description }
            </SNumberDescription>
        </SNumberItem>
    );
};

export default NumberItem;
